(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ph-knowledge-style"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ph-ingredient-library'))customElements.define('ph-ingredient-library',class extends HTMLElement{
 connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;this.cards=Array.from(this.querySelectorAll('[data-ingredient]'));this.search=this.querySelector('[data-search]');this.family=this.querySelector('[data-family]');this.limit=18;this.selected=new Set();this.querySelectorAll('[data-compare]').forEach(e=>e.checked=false);this.querySelectorAll('[data-enhance]').forEach(e=>e.hidden=false);this.search.addEventListener('input',()=>{this.limit=18;this.filter()},{signal});this.family.addEventListener('change',()=>{this.limit=18;this.filter()},{signal});this.querySelector('[data-reset]').addEventListener('click',()=>{this.search.value='';this.family.value='';this.limit=18;this.filter();this.search.focus()},{signal});this.querySelector('[data-more]').addEventListener('click',()=>{this.limit+=18;this.filter()},{signal});this.addEventListener('change',e=>{if(!e.target.matches('[data-compare]'))return;const key=e.target.value;if(e.target.checked&&this.selected.size>=3){e.target.checked=false;this.querySelector('[data-compare-status]').textContent=this.dataset.limitMessage;return;}e.target.checked?this.selected.add(key):this.selected.delete(key);this.comparison()},{signal});this.querySelector('[data-clear-compare]').addEventListener('click',()=>{this.selected.clear();this.querySelectorAll('[data-compare]').forEach(e=>e.checked=false);this.comparison()},{signal});this.openHash=()=>{let id;try{id=decodeURIComponent(location.hash.slice(1))}catch{return;}const c=this.cards.find(e=>e.id===id);if(!c)return;this.search.value='';this.family.value='';this.limit=Math.max(18,this.cards.indexOf(c)+1);this.filter();c.querySelector('details').open=true;c.scrollIntoView({block:'start',behavior:'instant'});};window.addEventListener('hashchange',this.openHash,{signal});this.querySelector('[data-view-compare]').addEventListener('click',()=>{const box=this.querySelector('[data-comparison]');box.scrollIntoView({block:'start',behavior:'instant'});box.focus({preventScroll:true})},{signal});this.comparison();this.filter();this.openHash();}
 filter(){const q=this.search.value.trim().toLocaleLowerCase();const family=this.family.value;const matching=this.cards.filter(c=>(!q||c.dataset.search.includes(q))&&(!family||c.dataset.family===family));this.cards.forEach(c=>c.hidden=true);matching.slice(0,this.limit).forEach(c=>c.hidden=false);this.querySelector('[data-result-count]').textContent=this.dataset.countLabel.replace('{count}',String(matching.length));this.querySelector('[data-empty]').hidden=matching.length>0;this.querySelector('[data-more]').hidden=matching.length<=this.limit;}
 comparison(){const box=this.querySelector('[data-comparison]'),table=this.querySelector('[data-comparison-table]');table.replaceChildren();const selected=this.cards.filter(c=>this.selected.has(c.dataset.ingredient));box.hidden=!selected.length;this.querySelector('[data-view-compare]').hidden=!selected.length;this.querySelector('[data-compare-status]').textContent=this.dataset.selectedLabel.replace('{count}',String(selected.length));if(!selected.length)return;const head=document.createElement('thead'),hr=document.createElement('tr');const corner=document.createElement('th');corner.textContent=this.dataset.compareHeading;hr.append(corner);selected.forEach(c=>{const th=document.createElement('th');th.scope='col';th.textContent=c.querySelector('h2').textContent;hr.append(th)});head.append(hr);table.append(head);const body=document.createElement('tbody');['flavour','pairings','useful_facts','nutrition','considerations','origin_context'].forEach(k=>{if(!selected.some(c=>c.querySelector('[data-value="'+k+'"]')?.textContent.trim()))return;const row=document.createElement('tr'),label=document.createElement('th');label.scope='row';label.textContent=this.dataset[k];row.append(label);selected.forEach(c=>{const td=document.createElement('td');td.textContent=c.querySelector('[data-value="'+k+'"]')?.textContent||'—';row.append(td)});body.append(row)});table.append(body);}
 disconnectedCallback(){this.abort?.abort();this.abort=null;}
});
if (!customElements.get('ph-tea-atlas')) customElements.define('ph-tea-atlas', class extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    const signal = this.abort.signal;
    this.places = Array.from(this.querySelectorAll('[data-place]'));
    this.links = Array.from(this.querySelectorAll('[data-origin-link]'));
    if (!this.places.length) return;
    const search = this.querySelector('[data-tea-search]');
    const more = this.querySelector('[data-tea-more]');
    const placeFilter = this.querySelector('[data-place-filter]');
    const familyFilter = this.querySelector('[data-tea-family-select]');
    const cards = Array.from(this.querySelectorAll('[data-tea-name]'));
    this.teaLimit = 12;
    this.filterTeas = () => {
      if (!search || !placeFilter || !more) return;
      const q = search.value.trim().toLocaleLowerCase();
      const country = (this.selectedId || '').split('origin-').pop();
      const family = familyFilter?.value || '';
      const matching = cards.filter(card => card.dataset.teaName.includes(q) && (!family || card.dataset.teaFamily === family) && (!placeFilter.checked || !country || card.dataset.teaOrigins.includes('|' + country + '|')));
      cards.forEach(card => card.hidden = true);
      matching.slice(0, this.teaLimit).forEach(card => card.hidden = false);
      more.hidden = matching.length <= this.teaLimit;
      this.querySelector('[data-tea-count]').textContent = this.dataset.countLabel.replace('{count}', String(matching.length));
      this.querySelector('[data-tea-empty]').hidden = matching.length > 0;
    };
    this.select = id => {
      if (id && !this.places.some(place => place.id === id)) return;
      this.selectedId = id;
      this.places.forEach(place => place.hidden = place.id !== id);
      this.links.forEach(link => link.setAttribute('aria-current', String(link.hash === '#' + id)));
      this.teaLimit = 12;
      this.filterTeas();
      const panel = this.places.find(place => place.id === id);
      const status = this.querySelector('[data-atlas-status]');
      const view = this.querySelector('[data-atlas-view]');
      const count = panel ? panel.querySelectorAll('.ph-atlas__product').length : 0;
      if (status) status.textContent = panel ? panel.querySelector('h2').textContent.trim() + ' · ' + (count === 1 ? this.dataset.oneLabel : this.dataset.manyLabel.replace('{count}', String(count))) : this.dataset.chooseLabel;
      if (view) { view.hidden = !panel; if (panel) view.setAttribute('href', '#' + panel.id); }
      this.updateZoom?.();
    };
    this.links.forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      let chosenLink = link;
      if (link.classList.contains('ph-atlas__pin') && event.detail > 0) {
        let shortestDistance = Infinity;
        this.links.filter(candidate => candidate.classList.contains('ph-atlas__pin')).forEach(candidate => {
          const bounds = candidate.getBoundingClientRect();
          const distance = Math.hypot(event.clientX - bounds.left - bounds.width / 2, event.clientY - bounds.top - bounds.height / 2);
          if (distance < shortestDistance) {
            shortestDistance = distance;
            chosenLink = candidate;
          }
        });
      }
      const id = chosenLink.hash.slice(1);
      history.replaceState(null, '', chosenLink.hash);
      this.select(id);

    }, {signal}));
    const defaultPlace = () => {
      const preferred = this.places.find(place => place.id.endsWith('origin-china')) || this.places.find(place => place.id.endsWith('origin-india'));
      if (preferred) return preferred.id;
      return this.places.slice().sort((a, b) => b.querySelectorAll('.ph-atlas__product').length - a.querySelectorAll('.ph-atlas__product').length)[0].id;
    };
    this.hash = () => {
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch { id = ''; }
      const match = this.places.find(place => place.id === id || place.id.endsWith('-' + id));
      this.select(id && match ? match.id : '');
    };
    /* Highlight countries that have a place record and make them clickable */
    const iso = {'albania':'ALB','argentina':'ARG','australia':'AUS','austria':'AUT','bangladesh':'BGD','bolivia':'BOL','bosnia and herzegovina':'BIH','brazil':'BRA','bulgaria':'BGR','burundi':'BDI','cambodia':'KHM','cameroon':'CMR','canada':'CAN','chile':'CHL','china':'CHN','colombia':'COL','croatia':'HRV','czechia':'CZE','czech republic':'CZE','ecuador':'ECU','egypt':'EGY','england':'GBR','ethiopia':'ETH','france':'FRA','georgia':'GEO','germany':'DEU','ghana':'GHA','greece':'GRC','guatemala':'GTM','hungary':'HUN','india':'IND','indonesia':'IDN','iran':'IRN','ireland':'IRL','israel':'ISR','italy':'ITA','japan':'JPN','kenya':'KEN','laos':'LAO','madagascar':'MDG','malawi':'MWI','malaysia':'MYS','mexico':'MEX','morocco':'MAR','mozambique':'MOZ','myanmar':'MMR','nepal':'NPL','netherlands':'NLD','new zealand':'NZL','nigeria':'NGA','north macedonia':'MKD','pakistan':'PAK','paraguay':'PRY','peru':'PER','philippines':'PHL','poland':'POL','portugal':'PRT','romania':'ROU','rwanda':'RWA','serbia':'SRB','south africa':'ZAF','south korea':'KOR','spain':'ESP','sri lanka':'LKA','sudan':'SDN','sweden':'SWE','taiwan':'TWN','tanzania':'TZA','thailand':'THA','tunisia':'TUN','turkey':'TUR','türkiye':'TUR','turkiye':'TUR','uganda':'UGA','ukraine':'UKR','united kingdom':'GBR','uk':'GBR','united states':'USA','usa':'USA','united states of america':'USA','uruguay':'URY','vietnam':'VNM','viet nam':'VNM','zimbabwe':'ZWE','mongolia':'MNG','russia':'RUS','kazakhstan':'KAZ','uzbekistan':'UZB','azerbaijan':'AZE','armenia':'ARM','lebanon':'LBN','jordan':'JOR','saudi arabia':'SAU','yemen':'YEM','oman':'OMN','united arab emirates':'ARE','cuba':'CUB','jamaica':'JAM','dominican republic':'DOM','honduras':'HND','nicaragua':'NIC','costa rica':'CRI','panama':'PAN','venezuela':'VEN','papua new guinea':'PNG','fiji':'FJI','mauritius':'MUS','réunion':'REU','reunion':'REU','seychelles':'SYC','comoros':'COM','sierra leone':'SLE','togo':'TGO','benin':'BEN','ivory coast':'CIV',"côte d'ivoire":'CIV','senegal':'SEN','mali':'MLI','niger':'NER','chad':'TCD','libya':'LBY','algeria':'DZA','somalia':'SOM','eritrea':'ERI','djibouti':'DJI','zambia':'ZMB','botswana':'BWA','namibia':'NAM','angola':'AGO','congo':'COG','democratic republic of the congo':'COD','gabon':'GAB','switzerland':'CHE','belgium':'BEL','denmark':'DNK','norway':'NOR','finland':'FIN','estonia':'EST','latvia':'LVA','lithuania':'LTU','belarus':'BLR','moldova':'MDA','slovakia':'SVK','slovenia':'SVN','montenegro':'MNE','kosovo':'KOS','cyprus':'CYP','malta':'MLT','iceland':'ISL','luxembourg':'LUX','bhutan':'BTN','afghanistan':'AFG','iraq':'IRQ','syria':'SYR','kyrgyzstan':'KGZ','tajikistan':'TJK','turkmenistan':'TKM','north korea':'PRK','hong kong':'HKG','singapore':'SGP','brunei':'BRN','east timor':'TLS','timor-leste':'TLS'};
    const countryPaths = new Map();
    this.links.filter(link => link.classList.contains('ph-atlas__pin')).forEach(pin => {
      const name = (pin.getAttribute('aria-label') || '').split('·')[0].trim().toLocaleLowerCase();
      const code = iso[name];
      const path = code && this.querySelector('.ph-atlas__countries path[data-country="' + code + '"]');
      if (!path) return;
      path.classList.add('is-origin');
      path.setAttribute('tabindex', '-1');
      if (!Array.from(countryPaths.values()).includes(path)) path.addEventListener('click', () => pin.click(), {signal});
      countryPaths.set(pin.hash.slice(1), path);
    });
    const paintCountries = id => new Set(countryPaths.values()).forEach(path => path.classList.toggle('is-current', Array.from(countryPaths).some(([placeId, countryPath]) => countryPath === path && placeId === id)));
    const baseSelect = this.select;
    this.select = id => { baseSelect(id); paintCountries(id); };
    this.querySelector('[data-atlas-selection]')?.removeAttribute('hidden');
    this.querySelector('[data-atlas-clear]')?.addEventListener('click', () => {
      history.replaceState(null, '', location.pathname + location.search);
      this.select('');
    }, {signal});
    this.querySelector('[data-atlas-view]')?.addEventListener('click', event => {
      const panel = this.places.find(place => place.id === this.selectedId);
      if (!panel) return;
      event.preventDefault();
      panel.scrollIntoView({block:'start', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      panel.querySelector('h2')?.focus({preventScroll:true});
    }, {signal});
    this.classList.add('is-ready');
    window.addEventListener('hashchange', this.hash, {signal});
    this.hash();
    this.loadPages(cards);
    this.querySelectorAll('[data-enhance]').forEach(element => element.hidden = false);
    search?.addEventListener('input', () => { this.teaLimit = 12; this.filterTeas(); }, {signal});
    familyFilter?.addEventListener('change', () => { this.teaLimit = 12; this.filterTeas(); }, {signal});
    placeFilter?.addEventListener('change', () => { this.teaLimit = 12; this.filterTeas(); }, {signal});
    more?.addEventListener('click', () => { this.teaLimit += 12; this.filterTeas(); }, {signal});
    const canvas = this.querySelector('[data-map-canvas]');
    const buttons = Array.from(this.querySelectorAll('[data-map-zoom]'));
    this.zoom = 1;
    this.querySelector('[data-map-tools]').hidden = false;
    const updateZoom = () => {
      canvas.style.width = (this.zoom * 100) + '%';
      const viewport = canvas.parentElement;
      viewport.classList.toggle('is-zoomed', this.zoom > 1);
      const active = this.links.find(link => link.classList.contains('ph-atlas__pin') && link.getAttribute('aria-current') === 'true');
      viewport.scrollLeft = this.zoom === 1 || !active ? 0 : active.offsetLeft - viewport.clientWidth / 2;
      viewport.scrollTop = this.zoom === 1 || !active ? 0 : active.offsetTop - viewport.clientHeight / 2;
      this.querySelector('[data-map-status]').textContent = Math.round(this.zoom * 100) + '%';
      buttons.forEach(button => button.disabled = (button.dataset.mapZoom === 'out' && this.zoom === 1) || (button.dataset.mapZoom === 'in' && this.zoom === 3));
    };
    this.updateZoom = updateZoom;
    buttons.forEach(button => button.addEventListener('click', () => {
      this.zoom = button.dataset.mapZoom === 'reset' ? 1 : Math.max(1, Math.min(3, this.zoom + (button.dataset.mapZoom === 'in' ? .5 : -.5)));
      updateZoom();
    }, {signal}));
    updateZoom();
  }
  async loadPages(cards) {
    let next = this.querySelector('[data-atlas-next]')?.href;
    const seen = new Set();
    try {
      while (next && !seen.has(next)) {
        seen.add(next);
        const url = new URL(next, location.href);
        if (url.origin !== location.origin) break;
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url, {signal:this.abort.signal});
        if (!response.ok) throw new Error('Atlas page unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = doc.querySelector('ph-tea-atlas');
        if (!source) throw new Error('Atlas section missing');
        for (const panel of this.places) {
          const incoming = [...source.querySelectorAll('[data-place]')].find(place => place.id === panel.id);
          if (!incoming) continue;
          const target = panel.querySelector('.ph-atlas__products');
          if (!target) continue;
          const links = new Set([...target.querySelectorAll('.ph-atlas__product')].map(card => card.getAttribute('href')));
          for (const card of incoming.querySelectorAll('.ph-atlas__product')) {
            if (links.has(card.getAttribute('href'))) continue;
            links.add(card.getAttribute('href'));
            target.appendChild(card);
          }
          const count = target.querySelectorAll('.ph-atlas__product').length;
          const label = panel.querySelector('[data-place-count]');
          if (label) label.textContent = count === 1 ? this.dataset.oneLabel : this.dataset.manyLabel.replace('{count}', String(count));
          const empty = panel.querySelector('[data-place-empty]');
          if (empty) empty.hidden = count > 0;
        }
        const directory = this.querySelector('.ph-atlas__directory');
        if (directory) {
          const links = new Set(cards.map(card => card.getAttribute('href')));
          for (const card of source.querySelectorAll('[data-tea-name]')) {
            if (links.has(card.getAttribute('href'))) continue;
            links.add(card.getAttribute('href'));cards.push(card);directory.appendChild(card);
          }
        }
        next = source.querySelector('[data-atlas-next]')?.href;
        this.select(this.selectedId);
      }
      if (!next) this.querySelector('[data-atlas-pages]')?.setAttribute('hidden', '');
    } catch (error) {
      if (error.name !== 'AbortError') this.querySelector('[data-atlas-pages]')?.removeAttribute('hidden');
    }
  }
  disconnectedCallback() { this.abort?.abort(); this.abort = null; }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ph-motion"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ph-storefront-motion'))customElements.define('ph-storefront-motion',class extends HTMLElement{
  connectedCallback(){
    if(this.controller)return;
    this.controller=new AbortController();
    this.preference=matchMedia('(prefers-reduced-motion: reduce)');
    this.seen=new WeakSet();
    const setup=()=>{
      this.observer?.disconnect();
      this.observer=null;
      const enabled=this.dataset.enabled==='true'&&!this.preference.matches;
      document.documentElement.dataset.phMotion=enabled?'on':'off';
      if(!enabled){document.getAnimations().filter(a=>a.id==='ph-enter').forEach(a=>a.cancel());return;}
      if(!('IntersectionObserver' in window))return;
      this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(!entry.isIntersecting)return;
        const element=entry.target;this.observer.unobserve(element);
        if(this.seen.has(element))return;
        this.seen.add(element);
        if(typeof element.animate!=='function')return;
        element.animate([{opacity:.75,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{id:'ph-enter',duration:420,easing:'cubic-bezier(.16,1,.3,1)',fill:'none'});
      }),{threshold:.12});
      this.observe(document);
    };
    this.observe=root=>root.querySelectorAll('.ph-counter__copy,.ph-counter__photograph,.ph-editorial__photo,.ph-editorial__copy,.ph-path,.collection__title,.ph-finder__intro,.ph-detail-story__heading,.ph-collection-intro__body,.article-template__hero-container,.main-page-title,.ph-autumn__copy,.ph-seasonal__head,.ph-seasonal__item,.ph-gifts__head,.ph-gifts__item,.ph-world,.ph-repeat__intro,.product__title,.product__media-wrapper,.ph-pumpkin-banner,.blog-articles__article,.article-template__content h2,.ph-bundle-story').forEach(el=>{if(!this.seen.has(el))this.observer?.observe(el);});
    this.preference.addEventListener('change',setup,{signal:this.controller.signal});
    document.addEventListener('shopify:section:load',event=>this.observe(event.target),{signal:this.controller.signal});
    setup();
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;this.observer?.disconnect();delete document.documentElement.dataset.phMotion;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ph-tea-shelf"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ph-tea-shelf')) return;
    const key = 'porter-hill:tea-shelf:v1';
    const subscribers = new Set();
    const shelves = new Set();
    let items = [];
    let readable = true;
    let loaded = false;
    let nextId = 0;
    const normalise = (value) => {
      if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
      if (typeof value.handle !== 'string' || !/^[a-z0-9][a-z0-9_-]{0,254}$/.test(value.handle)) return null;
      if (typeof value.title !== 'string' || !value.title.trim()) return null;
      if (typeof value.url !== 'string' || value.url.length > 1200) return null;
      let url;
      try { url = new URL(value.url, location.origin); } catch { return null; }
      if (url.origin !== location.origin || url.username || url.password) return null;
      const path = url.pathname.replace(/\/$/, '');
      const parts = path.split('/').filter(Boolean);
      if (parts.length < 2 || parts.length > 3 || parts.at(-2) !== 'products' || parts.at(-1) !== value.handle) return null;
      if (parts.length === 3 && !/^[a-z]{2}(?:-[a-z]{2})?$/i.test(parts[0])) return null;
      let image = '';
      if (typeof value.image === 'string' && value.image.length < 2000) {
        try {
          const candidate = new URL(value.image, location.origin);
          const sameShop = candidate.origin === location.origin && /^\/cdn\/shop\//.test(candidate.pathname);
          const shopifyCdn = candidate.hostname === 'cdn.shopify.com' && /^\/s\/files\//.test(candidate.pathname);
          if (candidate.protocol === 'https:' && !candidate.username && !candidate.password && (sameShop || shopifyCdn)) image = candidate.href;
        } catch {}
      }
      return { handle: value.handle, title: value.title.replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, 220), url: path, image, description: '' };
    };
    const parse = (raw) => {
      if (typeof raw !== 'string' || raw.length > 60000) return [];
      try {
        const values = JSON.parse(raw);
        if (!Array.isArray(values)) return [];
        const seen = new Set();
        const result = [];
        for (const value of values.slice(0, 100)) {
          const item = normalise(value);
          if (!item || seen.has(item.handle)) continue;
          seen.add(item.handle);
          result.push(item);
          if (result.length === 12) break;
        }
        return result;
      } catch { return []; }
    };
    const refresh = () => subscribers.forEach((callback) => callback());
    const read = () => {
      try { items = parse(localStorage.getItem(key)); readable = true; }
      catch { readable = false; }
      loaded = true;
    };
    const subscribe = (callback) => {
      if (!loaded) read();
      subscribers.add(callback);
      callback();
      return () => subscribers.delete(callback);
    };
    const commit = (next) => {
      try {
        if (next.length) localStorage.setItem(key, JSON.stringify(next));
        else localStorage.removeItem(key);
        items = next;
        readable = true;
        refresh();
        return true;
      } catch { return false; }
    };
    const activeShelf = () => [...shelves].find((shelf) => shelf.isConnected && !shelf.hasAttribute('disabled'));
    const message = (name) => activeShelf()?.dataset[name] || '';
    window.addEventListener('storage', (event) => {
      if (event.key !== key && event.key !== null) return;
      try { if (event.storageArea && event.storageArea !== localStorage) return; } catch { return; }
      read();
      refresh();
    });
    class TeaShelf extends HTMLElement {
      static get observedAttributes() { return ['disabled']; }
      connectedCallback() {
        if (this.unsubscribe) return;
        this.dialog = this.querySelector('dialog');
        this.heading = this.querySelector('h2');
        this.list = this.querySelector('[data-shelf-list]');
        this.status = this.querySelector('[role=status]');
        if (!this.dialog || !this.heading || !this.list || typeof this.dialog.showModal !== 'function') return;
        this.dialog.id = `ph-tea-shelf-${++nextId}`;
        this.heading.id = `${this.dialog.id}-title`;
        this.dialog.setAttribute('aria-labelledby', this.heading.id);
        this.handleClick = (event) => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-shelf-add-all')) this.addToBasket([...this.querySelectorAll('[data-shelf-cart]')]);
          if (button.hasAttribute('data-shelf-close')) this.close();
          if (button.hasAttribute('data-shelf-clear')) {
            const success = commit([]);
            this.status.textContent = message(success ? 'clearMessage' : 'errorMessage');
            if (success) this.heading.focus();
          }
          if (button.dataset.shelfRemove) {
            const index = items.findIndex((item) => item.handle === button.dataset.shelfRemove);
            const success = commit(items.filter((item) => item.handle !== button.dataset.shelfRemove));
            this.status.textContent = message(success ? 'removeMessage' : 'errorMessage');
            if (success) (this.list.querySelectorAll('[data-shelf-remove]')[Math.max(0, index - 1)] || this.heading).focus();
          }
        };
        this.handleKeys = (event) => {
          if (!this.dialog.open) return;
          if (event.key === 'Escape') { event.preventDefault(); this.close(); }
          if (event.key !== 'Tab') return;
          const focusable = [...this.dialog.querySelectorAll('button:not([disabled]), select:not([disabled]), input:not([disabled]), a[href], [tabindex="0"]')].filter((element) => !element.hidden && !element.closest('[hidden]'));
          const first = focusable[0];
          const last = focusable.at(-1);
          if (event.shiftKey && (document.activeElement === first || document.activeElement === this.heading)) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        };
        this.handleCancel = (event) => { event.preventDefault(); this.close(); };
        this.handleClose = () => { if (this.opener?.isConnected && !this.opener.disabled && !this.opener.hidden) this.opener.focus(); };
        this.handleSubmit = (event) => {
          if (!event.target.matches('[data-shelf-cart]')) return;
          event.preventDefault(); this.addToBasket([event.target]);
        };
        this.handleChange = (event) => {
          if (!event.target.matches('[data-shelf-cart] select')) return;
          const option = event.target.selectedOptions[0];
          const quantity = event.target.form.elements.quantity;
          quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
          if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
          quantity.value = quantity.min;
        };
        this.addEventListener('submit', this.handleSubmit);
        this.addEventListener('change', this.handleChange);
        this.addEventListener('click', this.handleClick);
        this.dialog.addEventListener('keydown', this.handleKeys);
        this.dialog.addEventListener('cancel', this.handleCancel);
        this.dialog.addEventListener('close', this.handleClose);
        shelves.add(this);
        this.unsubscribe = subscribe(() => this.render());
        refresh();
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.close();
        this.unsubscribe?.();
        this.unsubscribe = null;
        shelves.delete(this);
        this.removeEventListener('submit', this.handleSubmit);
        this.removeEventListener('change', this.handleChange);
        this.removeEventListener('click', this.handleClick);
        this.dialog?.removeEventListener('keydown', this.handleKeys);
        this.dialog?.removeEventListener('cancel', this.handleCancel);
        this.dialog?.removeEventListener('close', this.handleClose);
        refresh();
      }
      attributeChangedCallback() { if (this.hasAttribute('disabled')) this.close(); refresh(); }
      open(opener) {
        if (this.hasAttribute('disabled') || !this.dialog || this.dialog.open) return;
        this.opener = opener;
        this.status.textContent = '';
        this.render(true);
        this.dialog.showModal();
        this.heading.focus();
      }
      close() { if (this.dialog?.open) { this.dialog.close(); this.handleClose?.(); } }
      productUrl(item) {
        try {
          const root = new URL(this.dataset.root || '/', location.origin);
          if (root.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i.test(root.pathname)) return item.url;
          return root.pathname.replace(/\/?$/, '/') + 'products/' + item.handle;
        } catch { return item.url; }
      }
      updateAddAll() {
        const button = this.querySelector('[data-shelf-add-all]');
        button.hidden = items.length === 0;
        button.disabled = this.adding || this.list.querySelector('[data-shelf-loading]') !== null || !this.list.querySelector('[data-shelf-cart]');
      }
      async addToBasket(forms) {
        if (this.adding || !forms.length || forms.some(form => !form.reportValidity())) return;
        const additions = forms.map(form => ({id:form.elements.id.value,quantity:Number(form.elements.quantity.value)}));
        if (additions.some(item => !/^\d+$/.test(item.id) || !Number.isSafeInteger(item.quantity) || item.quantity < 1)) return;
        this.adding = true;
        const controls = [...this.querySelectorAll('button,select,input')].map(el => [el,el.disabled]);
        controls.forEach(([el]) => { el.disabled = true; });
        this.status.textContent = this.dataset.addingMessage;
        try {
          const response = await fetch(this.dataset.cartAddUrl + '.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:additions})});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.cartError);
          location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.status.textContent = (error.message && error.message !== 'Failed to fetch' ? error.message + ' ' : '') + this.dataset.cartError;
          this.adding = false; controls.forEach(([el,disabled]) => {el.disabled=disabled;}); this.updateAddAll();
        }
      }
      render(loadDetails = false) {
        if (!this.list || this.adding) return;
        const fragment = document.createDocumentFragment();
        items.forEach((item) => {
          const row = document.createElement('li');
          row.className = 'ph-shelf-item';
          if (item.image) {
            const image = document.createElement('img');
            image.src = item.image;
            image.alt = '';
            image.width = 72;
            image.height = 86;
            image.loading = 'lazy';
            image.addEventListener('error', () => image.remove(), { once: true });
            row.append(image);
          }
          const body = document.createElement('div');
          const title = document.createElement('h3');
          title.className = 'ph-shelf-product-title';
          title.textContent = item.title;
          const actions = document.createElement('div');
          actions.className = 'ph-shelf-product-actions';
          const link = document.createElement('a');
          link.href = this.productUrl(item);
          link.textContent = this.dataset.chooseLabel;
          link.setAttribute('aria-label', `${this.dataset.chooseLabel}: ${item.title}`);
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'ph-shelf-text-button';
          remove.dataset.shelfRemove = item.handle;
          remove.textContent = this.dataset.removeLabel;
          remove.setAttribute('aria-label', `${this.dataset.removeLabel}: ${item.title}`);
          actions.append(link, remove);
          body.append(title);
          if (loadDetails || this.dialog?.open) {
            const current = document.createElement('div');
            current.dataset.shelfLoading = '';
            current.textContent = this.dataset.loadingLabel;
            body.append(current);
            const endpoint = new URL(this.productUrl(item), location.origin);
            endpoint.searchParams.set('section_id', 'ph-shelf-product');
            fetch(endpoint, {credentials:'same-origin'})
              .then(response => {if (!response.ok) throw new Error('load'); return response.text();})
              .then(html => {
                if (!current.isConnected) return;
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const content = doc.querySelector('[data-ph-shelf-copy]');
                if (!content || content.dataset.productHandle !== item.handle) throw new Error('load');
                current.replaceChildren(...Array.from(content.childNodes));
                if (this.dataset.descriptions !== 'true') current.querySelectorAll('.ph-product-excerpt').forEach(el => el.remove());
              }).catch(() => {if(current.isConnected) current.textContent=this.dataset.loadError;})
              .finally(() => {delete current.dataset.shelfLoading;this.updateAddAll();});
          }
          body.append(actions);
          row.append(body);
          fragment.append(row);
        });
        this.list.replaceChildren(fragment);
        this.querySelector('[data-shelf-empty]').hidden = items.length > 0 || !readable;
        this.querySelector('[data-shelf-clear]').hidden = items.length === 0;
        this.querySelector('[data-shelf-unavailable]').hidden = readable;
        this.updateAddAll();
      }
    }
    class SaveProduct extends HTMLElement {
      static get observedAttributes() { return ['disabled']; }
      connectedCallback() {
        if (this.unsubscribe) return;
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role=status]');
        if (!this.button) return;
        this.item = normalise(this.dataset);
        this.handleClick = () => {
          if (this.button.disabled || !this.item || !activeShelf()) return;
          read();
          const saved = items.some((item) => item.handle === this.item.handle);
          if (!saved && items.length >= 12) { this.status.textContent = message('fullMessage'); refresh(); return; }
          const next = saved ? items.filter((item) => item.handle !== this.item.handle) : [...items, this.item];
          const success = commit(next);
          this.status.textContent = message(success ? (saved ? 'removeMessage' : 'saveMessage') : 'errorMessage');
        };
        this.button.addEventListener('click', this.handleClick);
        this.unsubscribe = subscribe(() => this.render());
      }
      disconnectedCallback() { this.unsubscribe?.(); this.unsubscribe = null; this.button?.removeEventListener('click', this.handleClick); }
      attributeChangedCallback() { this.render(); }
      render(loadDetails = false) {
        if (!this.button) return;
        const ready = !!activeShelf() && !!this.item;
        const saved = this.item && items.some((item) => item.handle === this.item.handle);
        this.button.hidden = !ready;
        this.button.disabled = !readable || this.hasAttribute('disabled');
        this.button.setAttribute('aria-pressed', String(!!saved));
        this.querySelector('[data-save-label]').textContent = saved ? this.dataset.savedLabel : this.dataset.saveLabel;
        this.querySelector('[data-save-fallback]').hidden = readable || !ready;
      }
    }
    class ShelfOpen extends HTMLElement {
      static get observedAttributes() { return ['disabled']; }
      connectedCallback() {
        if (this.unsubscribe) return;
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.handleClick = () => { if (!this.button.disabled) activeShelf()?.open(this.button); };
        this.button.addEventListener('click', this.handleClick);
        this.unsubscribe = subscribe(() => this.render());
      }
      disconnectedCallback() { this.unsubscribe?.(); this.unsubscribe = null; this.button?.removeEventListener('click', this.handleClick); }
      attributeChangedCallback() { this.render(); }
      render(loadDetails = false) {
        if (!this.button) return;
        const shelf = activeShelf();
        this.button.hidden = !shelf;
        this.button.disabled = this.hasAttribute('disabled');
        if (shelf) this.button.setAttribute('aria-controls', shelf.dialog.id);
        else this.button.removeAttribute('aria-controls');
        const count = this.querySelector('[data-shelf-count]');
        if (count) count.textContent = items.length ? `(${items.length})` : '';
      }
    }
    customElements.define('ph-tea-shelf', TeaShelf);
    customElements.define('ph-save-product', SaveProduct);
    customElements.define('ph-shelf-open', ShelfOpen);
  })();
  } catch(e) { console.error(e); }
})();

})();
